import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './MergedTable.module.css';
import tableMergeEnum from '../../../../enums/tableMergeEnum';
import split from '../../../../assets/images/Fireboard/split.png';

const MergedTable = props => {
  const { active, flexBasis, station, minus, onClick } = props;
  return (
    <div className={styles.container} style={{ border: active ? '0.4vh solid #ad0028' : null, width: flexBasis }}>
      <span
        onClick={() => onClick && onClick(station, tableMergeEnum.MERGE)}
        className={classNames({ [styles.centerAlignTxt]: true, [styles.tableNumber]: true })}
        style={{ width: minus ? '60%' : '100%' }}>
        {station.name}
      </span>
      {!minus ? null :
        <span
          className={classNames({ [styles.centerAlignTxt]: true, [styles.minus]: true })}
          onClick={() => onClick && onClick(station, tableMergeEnum.UNMERGE)}>
          <img src={split} alt='' className={styles.imgs} />
        </span>
      }
    </div>
  );
};

export default MergedTable;

MergedTable.propTypes = {
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  flexBasis: PropTypes.any,
  minus: PropTypes.bool,
  station: PropTypes.any,
};

MergedTable.defaultProps = {
  active: false,
  onClick: () => { },
  minus: false,
};
